import axios from 'axios'
import API_CONFIG from '../config/api.js'

// 创建axios实例
const authApi = axios.create({
  baseURL: API_CONFIG.API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器
authApi.interceptors.request.use(
  config => {
    // 可以在这里添加token等认证信息
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => {
    console.error('Request error:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
authApi.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    console.error('Response error:', error)
    return Promise.reject(error)
  }
)

// 认证相关API
export const authAPI = {
  // 用户登录
  login(credentials) {
    return authApi.post('/auth/login', credentials)
  },
  
  // 家庭注册
  register(familyData) {
    return authApi.post('/auth/register', familyData)
  },
  
  // 退出登录
  logout() {
    return authApi.post('/auth/logout')
  },
  
  // 刷新token
  refreshToken() {
    return authApi.post('/auth/refresh-token')
  },
  
  // 检查手机号是否已注册
  checkPhone(phone) {
    return authApi.get(`/auth/check-phone?phone=${phone}`)
  },
  
  // 获取当前用户信息
  getCurrentUser() {
    return authApi.get('/auth/me')
  },
  
  // 修改密码
  changePassword(passwordData) {
    return authApi.put('/auth/change-password', passwordData)
  }
}

export default authApi